import React, { useState } from "react";

import "./MainHeader.css";

function convertRemToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export default function MainHeader(props) {
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= convertRemToPixels(10)) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <header className={`main-header ${navbar ? "active" : ""}`}>
      {props.children}
    </header>
  );
}
